var map = {
	"./sticker_outline_balloon_purple.png": 1979,
	"./sticker_outline_bear_pink.png": 291,
	"./sticker_outline_burst_lime.png": 7152,
	"./sticker_outline_cat_blue.png": 1780,
	"./sticker_outline_checker_star_blue_black.png": 2054,
	"./sticker_outline_cloud_blue.png": 1522,
	"./sticker_outline_clover_green.png": 3865,
	"./sticker_outline_dog_cream.png": 4579,
	"./sticker_outline_double_star_pink.png": 4417,
	"./sticker_outline_flower_blue.png": 6296,
	"./sticker_outline_flower_purple_star_center.png": 4003,
	"./sticker_outline_flower_yellow.png": 7470,
	"./sticker_outline_frog_green.png": 6355,
	"./sticker_outline_heart_pink.png": 127,
	"./sticker_outline_heart_red.png": 6323,
	"./sticker_outline_lightning_orange.png": 5976,
	"./sticker_outline_music_note_purple.png": 8548,
	"./sticker_outline_polka_heart_black_pink.png": 2913,
	"./sticker_outline_rabbit_white.png": 7290,
	"./sticker_outline_smile_flower_blue.png": 8415,
	"./sticker_outline_smile_star_yellow.png": 7564,
	"./sticker_outline_sparkle_yellow.png": 662,
	"./sticker_outline_speech_bubble_pink.png": 7293,
	"./sticker_outline_star_pink.png": 2659,
	"./sticker_outline_starburst_orange.png": 7289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8898;